import React from 'react'
import {
  Header,
  Table,
  Input,
  Label,
  Button,
  Icon
} from 'semantic-ui-react'
import {
  withRouter
} from 'react-router'
import {
  Link
} from 'react-router-dom'
import ReactQueryParams from 'react-query-params';
import { areas } from './curriculum.js'
import ScreenContainer from './ScreenContainer.js'
import Mastery from './Mastery.js'
import Tier from './Tier.js'
import OptionalSelectTableHeaderCell from './OptionalSelectTableHeaderCell.js'
import OptionalItemSelectorCell from './OptionalItemSelectorCell.js'
import OptionalItemCounterCell from './OptionalItemCounterCell.js'
import OptionalCompareTableHeaderCells from './OptionalCompareTableHeaderCells.js'
import OptionalCompareItemCells from './OptionalCompareItemCells.js'

const rowCountLimit = 20;

class Search extends ReactQueryParams {
  defaultQueryParams = {
    q: '',
    caseInsensitive: true,
    matchAreas: true,
    matchUnits: true
  }
  state = {
    limitRowCount: true
  }
  filter = () => {
    console.log("Search2::filter");
    const query = decodeURIComponent(this.queryParams.q);
    const caseInsensitive = this.queryParams.caseInsensitive;
    const matchAreas = this.queryParams.matchAreas;
    const matchUnits = this.queryParams.matchUnits;
    let regexp = null;
    let queryError = null;
    try {
      regexp = new RegExp(query, caseInsensitive?"i":"");
      console.log(regexp);
    } catch (ex) {
      queryError = ex;
    }
    const filterOutput = this.filterOutcomes(regexp, matchAreas, matchUnits);
    const result = {
      queryRegexp: regexp,
      queryError: queryError,
      rowInfos: filterOutput.rowInfos,
      outcomeCount: filterOutput.outcomeCount
    };
    console.log("  result: ", result);
    return result;
  }
  filterOutcomes = (regex, matchAreas, matchUnits) => {
    console.log("Search2::filterOutcomes("+regex+","+matchAreas+","+matchUnits+")");
    let outcomeCount = 0;
    let rowInfos = [];
    if (regex) {
      for (const area of areas) {
        const areaMatch = matchAreas?regex.exec(area.name):null;
        const areaMatchStartIndex = areaMatch?areaMatch.index:undefined;
        const areaMatchString = areaMatch?areaMatch[0]:undefined;
        for (const unit of area.units) {
          const unitMatch = matchUnits?regex.exec(unit.name):null;
          const unitMatchStartIndex = unitMatch?unitMatch.index:undefined;
          const unitMatchString = unitMatch?unitMatch[0]:undefined;
          for (const outcome of unit.outcomes) {
            const outcomeMatch = regex.exec(outcome.name);
            if (outcomeMatch) {
              outcomeCount++;
              rowInfos.push({
                kind: 'outcome',
                area: area,
                unit: unit,
                outcome: outcome,
                matchStartIndex: outcomeMatch.index,
                matchString: outcomeMatch[0],
                unitMatchStartIndex: unitMatchStartIndex,
                unitMatchString: unitMatchString,
                areaMatchStartIndex: areaMatchStartIndex,
                areaMatchString: areaMatchString
              });
            } else if (unitMatch) {
              outcomeCount++;
              rowInfos.push({
                kind: 'unit',
                area: area,
                unit: unit,
                outcome: outcome,
                unitMatchStartIndex: unitMatchStartIndex,
                unitMatchString: unitMatchString,
                areaMatchStartIndex: areaMatchStartIndex,
                areaMatchString: areaMatchString
              });
            } else if (areaMatch) {
              outcomeCount++;
              rowInfos.push({
                kind: 'area',
                area: area,
                unit: unit,
                outcome: outcome,
                unitMatchStartIndex: unitMatchStartIndex,
                unitMatchString: unitMatchString,
                areaMatchStartIndex: areaMatchStartIndex,
                areaMatchString: areaMatchString
              });
            }
          }
        }
      }
    }
    const result = {
      rowInfos: rowInfos,
      outcomeCount: outcomeCount
    };
    console.log("  result:", result);
    return result;
  }
  inputChanged = (event, data) => {
    console.log("Search2::inputChanged", event, data);
    console.log("data.value:", data.value);
    console.log("this:", this);
    const query = data.value;
    const encodedQuery = encodeURIComponent(query);
    this.setQueryParams({
      q: encodedQuery
    }, true);
    this.setState({
      limitRowCount: true
    });
  }
  highlightMatch(text, matchStartIndex, matchString) {
    if (matchStartIndex===undefined) {
      return text;
    } else {
      return (
        <span>
          {text.substring(0, matchStartIndex)}
          <span style={{fontWidth: 'bold', color: '#fc6721'}}>
            {matchString}
          </span>
          {text.substring(matchStartIndex+matchString.length)}
        </span>
      );
    }
  }
  showAllRows = () => {
    console.log("Search2:showAllRows()");
    this.setState({
      limitRowCount: false,
    });
  }
  buildTable(regex, limitRowCount, rowInfos) {
    console.log("buildTable()");
    if (!regex) {
      return [];
    }
    const rows = [];
    let area = null;
    let unit = null;
    let rowCount = 0;
    for (const rowInfo of rowInfos) {
      rowCount++;
      if (limitRowCount && rowCount>rowCountLimit) {
        rows.push(
          <Table.Row key='more'>
            <Table.Cell colSpan={this.props.mode==='select'?'5':'4'}>
              <Button onClick={this.showAllRows}>
                Show All...
              </Button>
            </Table.Cell>
          </Table.Row>
        );
        break;
      }
      if (rowInfo.area!==area) {
        area = rowInfo.area;
        rows.push(
          <Table.Row warning key={area.id}>
            <Table.Cell collapsing>{area.id}</Table.Cell>
            <Table.Cell><Link to={"/area/"+area.id}><b>
              {this.highlightMatch(area.name, rowInfo.areaMatchStartIndex, rowInfo.areaMatchString)}
            </b></Link></Table.Cell>
            <Table.Cell collapsing></Table.Cell>
            <Table.Cell collapsing></Table.Cell>
            <OptionalItemCounterCell mode={this.props.mode} selection={this.props.selection} fqidPrefix={area.id}/>
            <OptionalCompareItemCells mode={this.props.mode} selections={this.props.selections} comparisonMode={this.props.comparisonMode} comparisonSelectionNames={this.props.comparisonSelectionNames} fqidPrefix={area.id} itemKind='outcomes'/>
          </Table.Row>
        );
      }
      if (rowInfo.unit!==unit) {
        unit = rowInfo.unit;
        rows.push(
          <Table.Row key={unit.fqid}>
            <Table.Cell collapsing disabled>{unit.fqid}</Table.Cell>
            <Table.Cell><Link to={"/unit/"+unit.fqid}>
              {this.highlightMatch(unit.name, rowInfo.unitMatchStartIndex, rowInfo.unitMatchString)}
            </Link></Table.Cell>
            <Table.Cell collapsing></Table.Cell>
            <Table.Cell collapsing></Table.Cell>
            <OptionalItemCounterCell mode={this.props.mode} selection={this.props.selection} fqidPrefix={unit.fqid}/>
            <OptionalCompareItemCells mode={this.props.mode} selections={this.props.selections} comparisonMode={this.props.comparisonMode} comparisonSelectionNames={this.props.comparisonSelectionNames} fqidPrefix={unit.fqid} itemKind='outcomes'/>
          </Table.Row>
        );
      }
      let outcome = rowInfo.outcome;
      let disabled = rowInfo.kind!=='outcome';
      rows.push(
        <Table.Row key={outcome.fqid}>
          <Table.Cell collapsing disabled>{outcome.id}</Table.Cell>
          <Table.Cell disabled={disabled}>
            {this.highlightMatch(outcome.name, rowInfo.matchStartIndex, rowInfo.matchString)}
          </Table.Cell>
          <Table.Cell collapsing textAlign='center'><Mastery mastery={outcome.mastery}/></Table.Cell>
          <Table.Cell collapsing textAlign='center'><Tier tier={outcome.tier}/></Table.Cell>
          <OptionalItemSelectorCell mode={this.props.mode} selection={this.props.selection} onToggle={this.props.onToggle} fqid={outcome.fqid}/>
          <OptionalCompareItemCells
            mode={this.props.mode}
            comparisonMode={this.props.comparisonMode}
            comparisonSelectionNames={this.props.comparisonSelectionNames}
            selections={this.props.selections}
            fqidPrefix={outcome.fqid}
          />
        </Table.Row>
      );
    }
    console.log(rows);
    return rows;
  }
  render() {
    console.log("Search2::render()");
    let query = decodeURIComponent(this.queryParams.q);
    console.log("  query:", query);
    console.log("  pathname:", this.props.history.location.pathname);
    console.log("  search:", this.props.history.location.search);
    console.log("  hash:", this.props.history.location.hash);

    const filterResult = this.filter();
    const rows = this.buildTable(filterResult.queryRegexp, this.state.limitRowCount, filterResult.rowInfos);
    return (
      <ScreenContainer mode={this.props.mode}>
        <Header as='h1'>Search Learning Outcomes</Header>
        <Input
          autoFocus
          error={!!filterResult.queryError}
          icon='search'
          placeholder='Search...'
          onChange={this.inputChanged}
          value={query}/>
        {
          filterResult.queryError?
            <Label basic color='red' pointing='left'>
              {filterResult.queryError.message}
            </Label>
          :<span></span>
        }
        &nbsp;
        <Label circular>{filterResult.outcomeCount}</Label>
        <br/>
        {rows.length
          ?
          <Table compact='very' basic='very' selectable>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell collapsing>
                </Table.HeaderCell>
                <Table.HeaderCell>
                  Name
                </Table.HeaderCell>
                <Table.HeaderCell collapsing textAlign='center'>
                  Mastery
                </Table.HeaderCell>
                <Table.HeaderCell collapsing textAlign='center'>
                  Tier
                </Table.HeaderCell>
                <OptionalSelectTableHeaderCell mode={this.props.mode} selection={this.props.selection}/>
                <OptionalCompareTableHeaderCells
                  mode={this.props.mode}
                  selections={this.props.selections}
                  comparisonMode={this.props.comparisonMode}
                  comparisonSelectionNames={this.props.comparisonSelectionNames}
                />
              </Table.Row>
            </Table.Header>
            <Table.Body>
              { rows }
            </Table.Body>
          </Table>
          :
          <Header disabled as='h2' icon textAlign='center'>
            <Icon name='search' />
            No Matching Outcomes
            <Header.Subheader>Enter a different search string (regular expression)</Header.Subheader>
          </Header>
        }

      </ScreenContainer>
    );
  }
}

export default withRouter(Search)